// extracted by mini-css-extract-plugin
module.exports = {"banner-modal":"personal-plan-banner-modal_banner-modal__Tez7H","message":"personal-plan-banner-modal_message__ZHWh9","prop":"personal-plan-banner-modal_prop__nsG5e"};